import type { EducationLevel } from 'models';
import { useQuery } from 'query';
import { getEducationsLevel } from '../services';
import { getEducationLevelsQueryKey } from './keys';

export const useEducationsLevel = () =>
  useQuery<EducationLevel[]>({
    async queryFn() {
      const { data } = await getEducationsLevel();
      return data;
    },
    queryKey: getEducationLevelsQueryKey(),
  });
